module.exports = __webpack_public_path__ + "static/media/picture-(61).71dd1ddf.JPG";